import React from 'react';
import { Link } from 'react-router-dom';
import back from '../dist/webImages/back.svg';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonCustomerCreateEdit = ({ heading }) => {
  return (
    <SkeletonTheme baseColor='#fff' highlightColor='#f0f0f0'>
      <div className='newscreate pr-10 max-lg:pr-6'>
        <Link to='/customers' className='back flex items-center mb-10 gap-2'>
          <img src={back} className='w-[2rem]' alt='' />
          <span className='text-[1.4rem] font-MluvkaBold'>{heading}</span>
        </Link>
        <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3'>
          <div className='grid grid-cols-2 gap-3 max-lg:grid-cols-1'>
            <Skeleton height={48} />
            <Skeleton height={48} />
          </div>
          <div className='grid grid-cols-2 gap-3 mt-4 max-lg:grid-cols-1'>
            <Skeleton height={48} />
            <Skeleton height={48} />
          </div>
          <Skeleton height={48} className='mt-4' />
          <Skeleton height={48} className='mt-4' />
          <Skeleton height={160} className='mt-4' />
          <Skeleton width={100} height={48} className='mt-10' />
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default SkeletonCustomerCreateEdit;
